export const getBulkTransferToLocationFlatfileHeader = (
	locations = [],
	transferNoteMandatory
): any[] => [
	{
		label: 'Asset ID',
		key: 'assetId',
		type: 'string',
		constraints: [{ type: 'required' }],
	},
	{
		label: 'Destination Location',
		key: 'locationId',
		type: 'enum',
		config: {
			options: locations,
		},
		alternates: ['Name'],
		constraints: [{ type: 'required' }],
	},
	{
		label: 'Transfer Note',
		key: 'transferNote',
		type: 'string',
		constraints: [...(transferNoteMandatory ? [{ type: 'required' }] : [])],
	},
	{
		label: 'Effective Date (MM/DD/yyyy)',
		key: 'transferDate',
		type: 'string',
	},
];

export const getBulkTransferToSLFlatfileHeader = (
	stockLocations = [],
	allEquipmentTypesNames = [],
	transferNoteMandatory
): any[] => [
	{
		label: 'Asset ID',
		key: 'assetId',
		type: 'string',
		constraints: [{ type: 'required' }],
	},
	{
		label: 'Destination Stock Location',
		key: 'stockLocationId',
		type: 'enum',
		config: {
			options: stockLocations,
		},
		alternates: ['Name'],
	},
	{
		label: 'Equipment Type',
		key: 'equipmentTypeId',
		type: 'enum',
		config: {
			options: allEquipmentTypesNames,
		},
		alternates: ['Equipment'],
		constraints: [{ type: 'required' }],
	},
	{
		label: 'Transfer Note',
		key: 'transferNote',
		type: 'string',
		constraints: [...(transferNoteMandatory ? [{ type: 'required' }] : [])],
	},
	{
		label: 'Effective Date (MM/DD/yyyy)',
		key: 'transferDate',
		type: 'string',
	},
];
